import { campaignCopy } from '@discovr/features';
import type { HoldReasonCode } from '@discovr/types';

const copy = campaignCopy.creator.hold;

export const HOLD_NOTE_MAX = 1000;

// Native cap in UTF-16 units: well above HOLD_NOTE_MAX code points (an emoji is two units),
// so the validation message shows instead of silent truncation.
export const HOLD_NOTE_INPUT_MAX_UNITS = HOLD_NOTE_MAX * 4;

// Remaining-character count at which the counter starts being announced.
export const HOLD_NOTE_ANNOUNCE_AT = 50;

export const HOLD_REASONS: ReadonlyArray<{ code: HoldReasonCode; label: string }> = [
  { code: 'creator_unresponsive', label: 'Creator unresponsive' },
  { code: 'creator_not_delivering', label: 'Creator not delivering (missed deadline / off-brief)' },
  { code: 'creator_declined', label: 'Creator no longer wants to work' },
  { code: 'brand_declined', label: 'Brand no longer wants to work' },
  { code: 'dispute_under_review', label: 'Dispute under review' },
  { code: 'compliance_review', label: 'Compliance / brand-safety review' },
  { code: 'product_logistics', label: 'Product or logistics issue' },
  { code: 'other', label: 'Other' },
];

export function holdReasonLabel(code: string): string {
  return HOLD_REASONS.find((r) => r.code === code)?.label ?? code;
}

export function holdNoteLength(note: string): number {
  // Backend limit is in runes, not UTF-16 units
  return Array.from(note.trim()).length;
}

export function holdNoteLengthError(note: string): string | null {
  return holdNoteLength(note) > HOLD_NOTE_MAX ? copy.note.tooLong(HOLD_NOTE_MAX) : null;
}

export function isHoldNoteMissing(code: HoldReasonCode | '', note: string): boolean {
  return code === 'other' && note.trim() === '';
}

export function holdNoteError(code: HoldReasonCode | '', note: string): string | null {
  if (!code) return copy.dialog.reasonRequired;
  if (isHoldNoteMissing(code, note)) return copy.note.required;
  return holdNoteLengthError(note);
}
